import React from "react";
import {
  getOneCountry,
  getOneLevel,
} from "../../../middlewares/breadCrumb/BreadCrumb";
import { countriesList } from "./data";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import { FiHome, FiChevronRight, FiMapPin, FiLayers } from "react-icons/fi";

export const DashboardIntro = ({ props }) => {
  const { sysAdmin } = useAdminContext();
  const { name, intro } = props || {};

  // Original sources
  const country = getOneCountry();
  const level = getOneLevel();

  // Preserve original mutation/augmentation logic
  let levelName = null;

  if (level.length > 0 && level[0]?.name !== "") {
    const country_id = level[0]?.data?.data?.country_id;
    const userCountry = countriesList.find((u) => u?.id === country_id);
    country.push(userCountry);
    levelName = level[0]?.name;
  } else if (country.length === 0) {
    const userCountry = countriesList.find((u) => u.name === sysAdmin?.country);
    country.push(userCountry);
  }

  const displayCountry = country?.[0]?.name || "—";
  const showIntro = name !== "undefined undefined";

  if (!showIntro) return null;

  return (
    <section className="w-full">
      <div className="mx-auto max-w-5xl">
        {/* Card container */}
        <div className="rounded-2xl border border-gray-200 bg-white p-4 sm:p-6 shadow-sm">
          {/* Heading + helper text */}
          <div className="mb-3 sm:mb-4">
            <h2 className="text-base sm:text-lg font-semibold tracking-tight text-gray-900">
              {intro}
              <span className="ml-2 text-gray-400">•</span>
              <span className="ml-2 text-gray-700">
                {displayCountry}
                {levelName ? ` / ${levelName}` : ""}
              </span>
            </h2>
            <p className="mt-1 text-xs text-gray-600">
              You’re viewing data scoped to the selected location and level.
              Use the filters above to change context.
            </p>
          </div>

          {/* Breadcrumbs */}
          <nav aria-label="Breadcrumb" className="mb-3">
            <ol className="flex flex-wrap items-center gap-x-2 gap-y-2 text-sm text-gray-600">
              <li className="inline-flex items-center gap-2">
                <FiHome className="h-4 w-4 text-gray-500" aria-hidden="true" />
                <span className="font-medium text-gray-700">Dashboard</span>
              </li>

              <li className="inline-flex items-center gap-2">
                <FiChevronRight className="h-4 w-4 text-gray-400" />
                <span className="inline-flex items-center gap-2">
                  <FiMapPin className="h-4 w-4 text-emerald-600" aria-hidden="true" />
                  <span className="text-gray-800">{displayCountry}</span>
                </span>
              </li>

              {levelName ? (
                <li className="inline-flex items-center gap-2">
                  <FiChevronRight className="h-4 w-4 text-gray-400" />
                  <span className="inline-flex items-center gap-2">
                    <FiLayers className="h-4 w-4 text-emerald-600" aria-hidden="true" />
                    <span className="text-gray-800">{levelName}</span>
                  </span>
                </li>
              ) : null}
            </ol>
          </nav>

          {/* Chips summary */}
          <div className="flex flex-wrap items-center gap-2">
            <span
              className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs text-gray-700"
              title="Selected country"
            >
              <FiMapPin className="h-3.5 w-3.5 text-emerald-600" />
              <span className="font-medium">{displayCountry}</span>
            </span>

            {levelName ? (
              <span
                className="inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs text-gray-700"
                title="Selected level"
              >
                <FiLayers className="h-3.5 w-3.5 text-emerald-600" />
                <span className="font-medium">{levelName}</span>
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
};
